import _ from 'lodash'

import { SystemRoles } from '../../lib/Codes'
import { unmapTeamMember } from '../../lib/Proxy/NarusTeamMember'
import { useAppDispatch, useAppSelector } from '../../store'
import { CareTeamExtensions } from '../PatientFolder/Standard/Demographics/NarusTeam/constants'
import MagicGrid from '../shared/MagicGrid'
import { PortedModal } from '../shared/NarusMaterial'
import FormattedPhone from '../shared/Phone/FormattedPhone'

import { HIDE_CARETEAM_MODAL } from './actions'

export function AlertsModal (): JSX.Element {
  const dispatch = useAppDispatch()
  const {
    showModal,
    careteam
  } = useAppSelector((state) => ({
    showModal: state.alerts.showModal,
    careteam: state.alerts.careteam
  }))

  const sortValues = (val: string): number => {
    if (val === 'pcp') {
      return 5
    }
    if (val === 'l4') {
      return 2
    }
    if (val === 'l5') {
      return 1
    }
    return 4
  }

  const tableDefinition = [
    {
      title: 'Name',
      displayFn: (entry: unknown) => {
        // unmapTeamMember(v)
        const first = _.capitalize(
          _.get(unmapTeamMember(entry), 'firstName')
        )
        const last = _.capitalize(_.get(unmapTeamMember(entry), 'lastName'))
        return [ last, first ].join(', ')
      }
    },
    {
      title: 'Role',
      displayFn: (entry: unknown) =>
        (SystemRoles.filter((r: Record<string, unknown>) => unmapTeamMember(entry).role === r.code)[0]
          ? SystemRoles.filter(
            (r: Record<string, unknown>) => unmapTeamMember(entry).role === r.code
          )[0].label
          : '')
    },
    {
      title: 'Phone',
      displayFn: (entry: unknown) => (
        <FormattedPhone number={unmapTeamMember(entry).phone} />
      )
    },
    {
      title: 'Email',
      displayFn: (entry: unknown) => unmapTeamMember(entry).email
    },
    {
      title: 'Alert Level',
      displayFn: (entry: unknown) =>
        (CareTeamExtensions?.filter(
          e => unmapTeamMember(entry).alertLevel === e.value
        )[0]
          ? CareTeamExtensions?.filter(
            e => unmapTeamMember(entry).alertLevel === e.value
          )?.[0]?.label
          : 'Level 2'),
      sortFn: (a: unknown, b: unknown) => {
        const aVal = sortValues(unmapTeamMember(a).alertLevel)
        const bVal = sortValues(unmapTeamMember(b).alertLevel)
        if (aVal > bVal) {
          return -1
        }

        if (aVal < bVal) {
          return 1
        }

        return 0
      }
    }
  ]

  return (
    <PortedModal
      open={showModal}
      title='Care Team'
      onCancel={() => dispatch({ type: HIDE_CARETEAM_MODAL })}
    >
      <MagicGrid
        rows={careteam}
        headers={tableDefinition}
        canDelete={false}
        disableGrid
        sortDir='asc'
        sortOn={4}
        itemName='Careteam'
      />
    </PortedModal>
  )
}
